<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/socialmediachef/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">How to become a social media chef.</h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            Before the dawn of social media, the opportunity to share your
            passion, creativity and love of food was really limited if you
            weren’t a professional.
          </p>
          <p>
            Qualified chefs dominated television, print and even online – after
            all, they are the experts, right?
          </p>
          <p>
            Well, if truth be told, not completely right. They may absolutely
            have the necessary qualifications – although many top chefs are
            self-taught and didn’t get any kind of formal training – but they
            have gone on to hone their skills in professional kitchens.
          </p>
          <p>
            Once platforms such as TikTok and Instagram became such worldwide
            phenomena, that opened the floodgates for anyone with a particular
            flair or interest to share it on a global level.
          </p>
          <p>
            Home cooks who previously may have just concocted dishes for their
            family and friends suddenly found a way to broaden their audience –
            and for many of them that has led to massive success.
          </p>
          <p>
            They may not ever be heading up a Michelin star restaurant, but
            that’s not to say they can’t create a very nice living by showcasing
            what they do best.
          </p>
          <p>
            Our Found book creators all fall into that category, people who have
            decided to share their home recipes online and at the same time
            letting hundreds of thousands – or in some cases millions – of
            strangers into their homes.
          </p>
        </div>

        <div class="col-md-8 offset-md-2">
          <div class="blog__double-image">
            <img src="@/assets/images/blog/socialmediachef/2.jpg" alt="image" />
            <img src="@/assets/images/blog/socialmediachef/3.jpg" alt="image" />
          </div>
        </div>

        <div class="col-md-8 offset-md-2 mt-3">
          <p>
            To be a social media cook you don’t need to worry about fine dining
            creations – the majority of people like to find recipes that they
            can relate to and that they can easily replicate.
          </p>
          <p>
            There are some ingredients that you will need, however, if this is a
            path you want to pursue. Confidence in front of the camera – this
            will of course increase over time – and bags of personality so that
            the viewing audience can engage with you.
          </p>
          <p>
            A bit of a thick skin helps as well – remember that no matter how
            hard you try, not everyone is going to like you. The downside of
            social media is it’s awash with keyboard warriors who love to be
            negative.
          </p>
          <p>
            Learn to ignore that and remember nobody can please everyone, simply
            concentrate on the positive!
          </p>
          <p>
            Once you’ve decided you’re going to give this a go, then the first
            thing to do is decide on a name and set up your platform. Try and
            come up with something that’s both relatable and relevant – and
            that’s memorable.
          </p>
          <p>
            It could reflect where you’re from, your style of cooking, who you
            cook for – it’s worth investing a bit of time to come up with
            something that’s right for you.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/socialmediachef/4.jpg"
            alt="image"
          />

          <p>
            You might want to consider investing in some home vlogging equipment
            which will fit in with your smartphone and includes LED lighting,
            tripods etc. You don’t have to spend a fortune – there are kits out
            there for as little as £50 – but it can certainly help make your
            finished product look professional.
          </p>
          <p>
            Before you start posting, have a few trial runs. See how long it
            takes for your recipes- most of them need to be fairly speedy – and
            ensure all the necessary equipment is close at hand.
          </p>
          <p>
            If you make a mistake don’t worry – it makes you look human and
            therefore more relatable. It’s worth doing a bit of research and
            checking out what other people are doing and what works best for
            them.
          </p>
          <p>
            Connecting with your audience at a personal level is the key to
            success. If you’re posting on Instagram, make sure you’re in the
            majority of the images – people will buy into you!
          </p>
          <p>
            Ask for feedback – this serves the purpose of making your followers
            believe their opinion matters and also gives you some insight into
            what they do and don’t enjoy.
          </p>
          <p>
            Also think about the ingredients that you use. Is there a packet
            mix/a sauce etc that you use on a regular basis and that will appear
            in your recipes? If so, make sure you tag the brand in.
          </p>
          <p>
            This is how successful social media influencers start to build their
            brand and enter into partnerships, where they can receive products
            or cash for showcasing a product – and of course the more followers
            you have, the more attractive to companies you become.
          </p>
          <p>
            To become a successful social media cook requires time and
            dedication but if you’re willing to put in the work, there are rich
            rewards to be had.
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag
  },

  data() {
    return {
      creatorHandle: '626ad14797861a0010350d6c',
      CarouselModes,
      socialLinks,
      buyNowLoading: false,
      creatorProducts: [],
      tags: ['General']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      redirectUrl: 'checkout/redirectUrl',
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  methods: {
    ...mapMutations({
      ADD_ITEM: 'checkout/ADD_ITEM'
    }),
    ...mapActions({
      createSession: 'checkout/createSession'
    }),
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleBuyNowClick(product) {
      this.buyNowLoading = true;
      this.ADD_ITEM({
        product,
        count: 1,
        productFormatId: getDefaultProductFormat(product)?._id
      });
      this.createSession()
        .then(() => {
          window.location.href = this.redirectUrl;
        })
        .catch((err) => {
          this.$showToastMessage(
            this.$get(err, 'response.data.message'),
            'Error',
            'danger'
          );
        })
        .finally(() => {
          this.buyNowLoading = false;
        });
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: contain;
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
